import { useMutation } from '@apollo/client';

import { UpdateContractLinesBillingCyclesCadence, UpdateContractLinesBillingCyclesCadenceVariables }
  from '@/graphql/contracts/_generated_/updateContractLinesBillingCyclesCadence.mutation';
import UpdateContractLinesBillingCyclesCadenceMutation from
  '@/graphql/contracts/updateContractLinesBillingCyclesCadence.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import { ALL_ITEMS } from '@/config/common.config';
import { notificationService } from '@/services/notification/notification.client';
import GetPaginatedBillingCyclesQuery from '@/graphql/contracts/getPaginatedFilteredBillingCycles.query.gql';
import { useSelectedLines }
  from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';

export default function useUpdateBillingCadence(contractId: UUID) {
  const selectedLineRows = useSelectedLines();

  const [_updateBillingCadence, { loading }] = useMutation<UpdateContractLinesBillingCyclesCadence,
  UpdateContractLinesBillingCyclesCadenceVariables>(
    UpdateContractLinesBillingCyclesCadenceMutation,
    {
      client: apolloClientContracts,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetBCContractLinesQuery,
          variables: {
            filter: {
              contractId: { eq: contractId }
            },
            first: ALL_ITEMS
          }
        },
        {
          query: GetPaginatedBillingCyclesQuery,
          variables: {
            filter: {
              contractLineID: {
                containsValues: selectedLineRows.map(cl => cl.id)
              }
            }
          }
        }
      ],
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => {
        notificationService.open({
          title: 'Billing Cycles Updated',
          text: 'Billing Cycles successfully updated',
          type: 'success'
        });
      }
    }
  );

  const updateBillingCadence = (input: UpdateContractLinesBillingCyclesCadenceVariables) => {
    _updateBillingCadence({
      variables: input
    });
  };

  return {
    updateBillingCadence,
    isLoadingUpdateBillingCadence: loading,
  } as const;
}
